// extracted by mini-css-extract-plugin
module.exports = {"note":"_93444fe79c--note--3oItc","danger":"_93444fe79c--danger--1hKqT","icon":"_93444fe79c--icon--1ORDU","cont":"_93444fe79c--cont--2yYuF"};